export const getLoopingMode = store => {
  return store.settings.loopingMode;
};

export const getIsMuted = store => Boolean(store?.settings?.isMuted);
